import { FC, useId } from "react";

export const BedrockIcon: FC<{ className?: string }> = ({ className }) => {
  const id = useId();

  const clipPathId0 = `bedrock-clip-path-0-${id}`;

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="16"
      viewBox="0 0 12 16"
      fill="none"
    >
      <g clip-path={`url(#${clipPathId0})`}>
        <path
          d="M5.98727 8.78022L10.3012 4.37363L8.734 2.77097L5.98657 0.00126648V8.77955L5.98727 8.78022Z"
          fill="#9FF7EC"
        />
        <path d="M5.9873 15.9826L0.5 11.2006V5.55507" fill="#BADEFF" />
        <path
          d="M5.9873 11.1732C5.9873 11.1732 2.04666 7.16388 0.5 5.55507L5.9873 11.1732Z"
          fill="#CFE6FF"
        />
        <path
          d="M11.48 5.55576V11.1822L5.98657 15.9805V11.1712C5.98657 11.1712 9.93337 7.16182 11.48 5.55303"
          fill="#BCCFFF"
        />
        <path
          d="M5.98661 8.78024C5.98661 8.78024 2.9659 5.72562 1.67542 4.36815L3.23578 2.7703L5.98661 0.00196075V8.78024Z"
          fill="#C5C5FF"
        />
        <path
          d="M5.9873 15.9826V11.1732C5.9873 11.1732 9.93343 7.16388 11.4801 5.55507L5.9873 15.9791V15.9826Z"
          fill="#9077ED"
        />
        <path
          d="M0.5 5.55507C2.04392 7.16388 5.9873 11.1732 5.9873 11.1732V15.9819L0.5 5.55507Z"
          fill="#5E9EFC"
        />
        <path
          d="M10.3019 4.37363L5.98657 8.78091V5.94752L10.3019 4.37432V4.37363Z"
          fill="#A181F7"
        />
        <path
          d="M1.67615 4.36882C2.968 5.72629 5.98736 8.78091 5.98736 8.78091V5.94752L1.67615 4.36882Z"
          fill="#61A9FF"
        />
      </g>
      <defs>
        <clipPath id={clipPathId0}>
          <rect
            width="11"
            height="15.9975"
            fill="white"
            transform="translate(0.5 0.00126648)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
